import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'jb-navigation-block-skeleton',
  templateUrl: './navigation-block-skeleton.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationBlockSkeletonComponent {}
